const rapidocStyles = `
    .nav-method.as-colored-text {
        border-radius: 18px !important;
        color: #ffffff !important;
        text-align: center;
        background-color: #0095DB;
        padding: 2px 8px 3px !important;
        margin-top: -2px;
    }

    .nav-method.as-colored-text.get {
        background-color: #8BC34A !important;
    }

    .nav-method.as-colored-text.post {
        background-color: #366BF1 !important;
    }

    .nav-method.as-colored-text.put {
        background-color: #DD6E00 !important;
    }

    .nav-method.as-colored-text.patch {
        background-color: #7B1FA2 !important;
    }

    .nav-method.as-colored-text.delete {
        background-color: #CE0022 !important;
    }
`;

export default rapidocStyles;
